/* 
Bridge de comunicación con la Api, diferentes funciones para coger información de los movimientos del usuario.
*/
import {
  CAPITALIZEFIRSTLETTER,
  FORMATDATE,
  GETDATA
} from "../constants";
import { LOCAL } from "../config";

export default class Movement {
  static INSTANCE = new Movement();

  listMovement = [ //Ejemplo de movimiento
    {
      id: 50,
      center: "Bolera Gorbea",
      date: "1993-12-15",
      description: "Descripcion",
      detail: "Detalle",
      points: 100,
      saldo: 100
    }
  ];

  Movement() { }

  getListMovement = userId => {
    return new Promise((resolve, reject) => {
      if (!LOCAL) {
        let url = `/DCMovRedems/Movimientos?cliente_id=${userId}`;

        GETDATA(url, response => {
          const parseResponse = response.data.map(item => {
            return {
              id: item.id,
              center: CAPITALIZEFIRSTLETTER(item.centro.trim()),
              date: FORMATDATE(item.fecha),
              description: item.descripcion,
              detail: item.detalle,
              point: item.puntos,
              balance: item.saldo
            };
          });
          this.listMovement = parseResponse;
          resolve(this.listMovement);
        }, error => {
          reject(error);
        });

      } else {
        resolve(this.listMovement);
      }
    });
  };
}
